import config from '../config'
let mixin = {
    methods: {
        // 获取页面传参
        getUrlParam(name) {
            let reg = new RegExp('(^|&)' + name + '=([^&]*)(&|$)')
            let result = window.location.search.substr(1).match(reg)
            return result ? decodeURIComponent(result[2]) : null
        },
        // 页面跳转
        loadPage(routerName, param) {
            if (param) {
                this.$router.push({name: routerName, query: param})
            } else {
                this.$router.push({name: routerName})
            }
        },
        // alert
        successTips(msg) {
            alert(msg || '操作成功！')
        },
        // alert
        errorTips(msg) {
            alert(msg || '哪里不对了~')
        },
        // 返回上个页面
        goBack() {
            this.$router.go(-1)
        },
        // 去首页
        goHome() {
            this.loadPage('index')
        },
        // 登录页
        goSignIn() {
            window.location.href = '/login'
        },
        goSignUp() {
            window.location.href = '/register'
        },
        ajax(param) {
            var token = this.$store.getters.getToken || this.$PcLockr.get('token')
            var hostCode = this.$store.getters.getHostCode ? this.$store.getters.getHostCode : window.location.hostname
            let {type, url, data, success, isUnMusk, error, complete} = param
            if (isUnMusk) {
                this.$pcNProgress.start()
            }
            this.$http({
                headers: {
                    token: token,
                    domain: hostCode,
                    'content-language': 'zh-CN',
                    'Content-Type': 'application/json;charset=UTF-8'
                },
                method: type || 'GET',
                url: config.baseUrl + url || '',
                params: !type || type === 'GET' ? data : {},
                data: data || {}
            }).then((res) => {
                this.$pcNProgress.done()
                switch (res.data.code) {
                case 0:
                    success(res.data)
                    break
                case '0000':
                    success(res.data)
                    break
                case 100113:
                    this.$pcMessage.error(res.data.msg || res.data.desc || '登录过期，请重新登录！')
                    this.loadPage('login')
                    break
                case 4000002:
                    this.$pcMessage.error(res.data.msg || res.data.desc || '请先登陆后查看！')
                    this.loadPage('login')
                    break
                default:
                    if (error) {
                        error(res.data.msg || res.data.desc || '访问出错，请稍后再试！')
                    } else {
                        this.$pcMessage.error(res.data.msg || res.data.desc || '访问出错，请稍后再试！')
                    }
                }
            }).catch(error => {
                console.error(error)
                this.$pcNProgress.done()
            }).finally(() => {
                if (complete) {
                    complete()
                }
            })
        },
        ajaxPNG(param) {
            var token = this.$store.getters.getToken || this.$PcLockr.get('token')
            var hostCode = this.$store.getters.getHostCode ? this.$store.getters.getHostCode : window.location.hostname
            let {type, url, data, success, isUnMusk, error, complete} = param
            if (isUnMusk) {
                this.$pcNProgress.start()
            }
            this.$http({
                headers: {
                    token: token,
                    domain: hostCode,
                    'Content-Type': 'application/json',
                    'Accept': 'application/json;q=0.5'
                },
                method: type || 'GET',
                url: config.baseUrl + url || '',
                params: !type || type === 'GET' ? data : {},
                data: data || {},
                responseType: 'blob'
            }).then((res) => {
                this.$pcNProgress.done()
                if (res.status) {
                    success(res.data)
                } else {
                    error(res.data.msg || res.data.desc || '访问出错，请稍后再试！')
                }
            }).catch(error => {
                console.error(url)
                console.error(error)
                this.$pcNProgress.done()
            }).finally(() => {
                if (complete) {
                    complete()
                }
            })
        },
        commonAjax(param) {
            var token = this.$store.getters.getToken ? this.$store.getters.getToken : ''
            var hostCode = this.$store.getters.getHostCode ? this.$store.getters.getHostCode : window.location.hostname
            let {type, url, data, success, isUnMusk, error, complete} = param
            if (isUnMusk) {
                this.$pcNProgress.start()
            }
            this.$http({
                headers: {
                    token: token,
                    domain: hostCode,
                    'Content-Type': 'application/json;charset=UTF-8'
                },
                method: type || 'GET',
                url: config.commonUrl + url || '',
                params: type === '' || type === 'GET' ? data : {},
                data: data || {}
            }).then((res) => {
                this.$pcNProgress.done()
                switch (res.data.code) {
                case 0:
                    success(res.data)
                    break
                case '0000':
                    success(res.data)
                    break
                case 100113:
                    this.$store.commit('clearLoginMsg')
                    this.$store.commit('cleatCartMsg')
                    this.$pcMessage.error(res.data.msg || res.data.desc || '登录过期，请重新登录！')
                    this.loadPage('login')
                    break
                case 4000002:
                    this.$pcMessage.error(res.data.msg || res.data.desc || '请先登陆后查看！')
                    this.loadPage('login')
                    break
                default:
                    if (error) {
                        error(res.data.msg || res.data.desc || '访问出错，请稍后再试！')
                    } else {
                        this.$pcMessage.error(res.data.msg || res.data.desc || '访问出错，请稍后再试！')
                    }
                }
            }).catch(error => {
                console.error(url)
                console.error(error)
                this.$pcNProgress.done()
            }).finally(() => {
                if (complete) {
                    complete()
                }
            })
        },
        // 导出
        exportFileRequest(param) {
            var token = this.$store.getters.getToken ? this.$store.getters.getToken : ''
            var hostCode = this.$store.getters.getHostCode ? this.$store.getters.getHostCode : window.location.hostname
            let {type, url, data, isUnMusk, name} = param
            if (isUnMusk) {
                this.$pcNProgress.start()
            }
            this.$http({
                headers: {
                    token: token,
                    domain: hostCode,
                    'Content-Type': 'application/json;charset=UTF-8'
                },
                method: 'GET',
                url: config.baseUrl + url || '',
                params: type === '' || type === 'GET' ? data : {},
                data: data || {},
                responseType: 'blob'
            }).then((res) => {
                // new Blob([data])用来创建URL的file对象或者blob对象
                let url = window.URL.createObjectURL(new Blob([res.data]))
                // 生成一个a标签
                let link = document.createElement('a')
                link.style.display = 'none'
                link.href = url
                // 生成时间戳
                link.download = `${name}.xls`
                document.body.appendChild(link)
                link.click()
            }).catch(error => {
                this.$pcMessage.error('下载失败' || error)
            }).finally(() => {
            })
        },
        logout() {
            this.$confirm('确定要退出当前账号吗?', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
                this.ajax({
                    type: 'get',
                    url: '/userInfo/logout',
                    success: () => {
                        this.$store.commit('clearLoginMsg')
                        this.$store.commit('cleatCartMsg')
                        window.location.href = '/login'
                    },
                    error: (error) => {
                        this.$pcMessage.error(error || '访问出错，请稍后再试！')
                    }
                })
            }).catch(() => {

            })
        },
        // 获得真实价格
        getRealPrice(priceLeverList, salePrice) {
            var price = 0
            let userInfo = this.$PcLockr.get('userInfo')
            if (userInfo && userInfo.accountPlant && userInfo.agentInfo && userInfo.plantDTO && userInfo.plantDTO.enableLevelPrice === 1 && priceLeverList) {
                var tempLevel = (userInfo.agentInfo.agentLevel2 === 1 || userInfo.agentInfo.agentLevel2 === 3) ? 1 : 2
                priceLeverList.forEach(item => {
                    if (item.lever === tempLevel) {
                        price = item.price || 0
                    }
                })
            }
            return price || salePrice
        },
        dateFormat(date, format) {
            date = typeof date === 'string' ? date.replace(/-/g, '/') : date
            date = new Date(date)
            var map = {
                'M': date.getMonth() + 1, // 月份
                'd': date.getDate(), // 日
                'h': date.getHours(), // 小时
                'm': date.getMinutes(), // 分
                's': date.getSeconds(), // 秒
                'q': Math.floor((date.getMonth() + 3) / 3), // 季度
                'S': date.getMilliseconds() // 毫秒
            }
            format = format.replace(/([yMdhmsqS])+/g, function(all, t) {
                var v = map[t]
                if (v !== undefined) {
                    if (all.length > 1) {
                        v = '0' + v
                        v = v.substr(v.length - 2)
                    }
                    return v
                } else if (t === 'y') {
                    return (date.getFullYear() + '').substr(4 - all.length)
                }
                return all
            })
            return format
        },
        // json拷贝
        jsonCopy(form, json) {
            for (var key in form) {
                if (json.hasOwnProperty(key)) {
                    form[key] = json[key] !== null && json[key] !== undefined ? json[key] : ''
                }
            }
            return form
        },
        // 字段的验证，支持非空、手机、邮箱的判断
        validate(value, type) {
            // 非空验证
            if (type === 'require') {
                return !!value
            }
            // 手机号验证
            if (type === 'phone') {
                return /^1\d{10}$/.test(value)
            }
            // 邮箱格式验证
            if (type === 'email') {
                return /^(\w)+(\.\w+)*@(\w)+((\.\w{2,3}){1,3})$/.test(value)
            }
            // 纳税人识别号
            if (type === 'taxNum') {
                return /[0-9A-HJ-NPQRTUWXY]{2}\d{6}[0-9A-HJ-NPQRTUWXY]{10}/.test(value)
            }
        },
        // 复制内容
        copyWord(e, text) {
            const clipboard = new this.clipboard(e.target, { text: () => text })
            clipboard.on('success', e => {
                this.$pcMessage.success('复制成功')
                // 释放内存
                clipboard.off('error')
                clipboard.off('success')
                clipboard.destroy()
            })
            clipboard.on('error', e => {
                // 不支持复制
                this.$pcMessage.error('复制失败')
                // 释放内存
                clipboard.off('error')
                clipboard.off('success')
                clipboard.destroy()
            })
            clipboard.onClick(e)
        },
        // 判断是否图片
        ifImg(url) {
            var imgType = ['png', 'jpg', 'jpeg', 'gif']
            var itemList = url.split('.')
            var type = itemList.length > 1 ? itemList[itemList.length - 1] : ''
            type = type.toLowerCase()
            if (imgType.includes(type)) {
                return true
            }
        }
    }
}

export default mixin



// WEBPACK FOOTER //
// ./src/mixins/index.js